import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';

import { AdvancedPlatformsActions } from './advanced-platforms.action';
import { AdvancedPlatformsService } from '../../services/advanced-platforms/advanced-platforms.service';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AdvancedPlatformsEffects {
  getPlatforms$ = createEffect(() => this.actions$
    .pipe(
      ofType(AdvancedPlatformsActions.getPlatforms),
      switchMap(() => this.advancedPlatformsService.getPlatformsList()),
      map((platforms) => ({
        type: AdvancedPlatformsActions.getPlatformsSuccess,
        payload: platforms,
      })),
    )
    .pipe(
      catchError((error) =>
        this.handlerToastError(
          AdvancedPlatformsActions.getPlatformsError,
          error,
        ),
      ),
      share(),
    ));

  getSubscribes$ = createEffect(() => this.actions$
    .pipe(
      ofType(AdvancedPlatformsActions.getSubscribes),
      switchMap(() => this.advancedPlatformsService.getSubscriptions()),
      map((userSubscriptions) => {
        return {
          type: AdvancedPlatformsActions.getSubscribesSuccess,
          payload: userSubscriptions,
        };
      }),
    )
    .pipe(
      catchError((error) =>
        this.handlerToastError(
          AdvancedPlatformsActions.getSubscribesError,
          error,
        ),
      ),
      share(),
  ));

  getClientsTradedOperationsCount$ = createEffect(() => this.actions$.pipe(
      ofType(AdvancedPlatformsActions.getClientsTradedOperationsCount),
      switchMap((action: any) =>
        this.advancedPlatformsService
          .getClientsTradedOperationsCount(action.payload.reqParams)
          .pipe(
            map((apiResponse) => {
              if (apiResponse.hasError) {
                return {
                  type: AdvancedPlatformsActions.getClientsTradedOperationsCountError,
                  payload: { error: apiResponse.messages[0].message, platformId: action.payload.platformId },
                };
              }

              return {
                type: AdvancedPlatformsActions.getClientsTradedOperationsCountSuccess,
                payload: { trades: apiResponse.value[0], platformId: action.payload.platformId },
              };
            }),
            catchError((error) =>
              of({
                  type: AdvancedPlatformsActions.getClientsTradedOperationsCountError,
                  payload: { error, platformId: action.payload.platformId },
              }),
            ),
          ),
      ),
      share(),
    ));

  setSubscribes$ = createEffect(() => this.actions$.pipe(
      ofType(AdvancedPlatformsActions.setSubscribe),
      switchMap((action: any) =>
        this.advancedPlatformsService.setSubscription(action.payload)
          .pipe(
            switchMap((result) => [
              {
                type: AdvancedPlatformsActions.setSubscribeSuccess,
                payload: result,
              },
              {
                type: AdvancedPlatformsActions.getSubscribes,
              },
            ]),
            catchError((error) => {
              // Retornando id fixo da plataforma temporariamente, mudar junto com a implementação da API
              return of({
                type: AdvancedPlatformsActions.setSubscribeError,
                payload: { error, platformId: action.payload.platformId },
              }); },
            ),
          ),
      ),
      share(),
    ));

  constructor(
    private actions$: Actions,
    private advancedPlatformsService: AdvancedPlatformsService,
    private toastr: ToastrService,
  ) {}

  private handlerToastError(actionType: any, error: any) {
    this.toastr.error(`Ops! Ocorreu um erro, por favor tente mais tarde.`, '', {
      timeOut: 5000,
      progressBar: true,
      positionClass: 'toast-bottom-center',
      toastClass: 'toast--default font-small--medium font-light-color',
    });

    return of({ type: actionType, payload: error });
  }
}
